export default __webpack_public_path__ + "static/media/golangicon.91506d9f.svg";